import { editorViewCtx } from '@milkdown/kit/core';
import type { Ctx } from '@milkdown/kit/ctx';
import type { Node as ProseMirrorNode } from '@milkdown/kit/prose/model';
import { TextSelection } from '@milkdown/kit/prose/state';

/** Inserts text at cursor, replacing any preceding slash command */
export const insertTextAtCursor = (ctx: Ctx, text: string) => {
  const view = ctx.get(editorViewCtx);
  const { state } = view;
  const { tr, selection, doc } = state;
  const { from } = selection;

  const textBefore = doc.textBetween(Math.max(0, from - 20), from, '\n', '\ufffc');
  const slashMatch = textBefore.match(/\/[a-zA-Z]*$/);

  let transaction = tr;
  if (slashMatch) {
    const slashStart = from - slashMatch[0].length;
    transaction = transaction.delete(slashStart, from).insertText(text, slashStart);
  } else {
    transaction = transaction.insertText(text, from);
  }

  view.dispatch(transaction.scrollIntoView());
};

/**
 * Inserts a block node at cursor, replacing the current paragraph.
 * Sets cursor inside the block at the specified offset (default: 2 for block > paragraph > cursor).
 */
export const insertBlockAtCursor = (ctx: Ctx, blockNode: ProseMirrorNode, cursorOffset = 2) => {
  const view = ctx.get(editorViewCtx);
  const { state } = view;
  const { tr, selection } = state;
  const { $from } = selection;

  // Find the parent block to replace (use before/after to include the node itself)
  const blockStart = $from.before($from.depth);
  const blockEnd = $from.after($from.depth);

  // Replace the current block with the new block node
  let transaction = tr.replaceWith(blockStart, blockEnd, blockNode);

  // Set cursor inside the block
  const cursorPos = blockStart + cursorOffset;
  transaction = transaction.setSelection(TextSelection.create(transaction.doc, cursorPos));

  view.dispatch(transaction.scrollIntoView());
};
